import React, { useState, useEffect } from 'react';
import sectiondata from '../../data/sections.json';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';
import { GetPropertyList } from '../../request/apiRquest';


import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Spin } from 'antd';

const Property = () => {

  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false
  };

  const [properties, setProperties] = useState([]);
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [propertiesPerPage] = useState(12);

  let publicUrl = process.env.PUBLIC_URL + '/';
  let imagealt = 'image';
  let data = sectiondata.property;

  const getpropertylist = () => {
    setLoading(true);
    GetPropertyList().then((res) => {
      setProperties(res);
      setFilteredProperties(res); // Initialize filtered properties with all properties
      setLoading(false);
    });
  };

  useEffect(() => {
    getpropertylist();
  }, []);

  // Filter properties based on category
  const filterProperties = (category) => {
    setActiveFilter(category);
    setCurrentPage(1); // Reset to first page when filter changes

    if (category === 'all') {
      setFilteredProperties(properties);
    } else {
      const filtered = properties.filter(property =>
        property.category && property.category.toLowerCase() === category.toLowerCase()
      );
      setFilteredProperties(filtered);
    }
  };

  // Pagination logic

  const totalPages = Math.ceil(filteredProperties.length / propertiesPerPage);

  const currentProperties = filteredProperties.slice(0, currentPage * propertiesPerPage);

  const loadMore = () => {
    setCurrentPage(prevPage => prevPage + 1);
  }

  return (
    <div className="property-area pd-top-100">
      <div className="container">
        <div className="row custom-gutter">
          <div className="col-lg-12">
            <div className="property-filter-menu-wrap">
              <div className="property-filter-menu portfolio-filter text-center">
                <button
                  className={activeFilter === 'all' ? 'active' : ''}
                  onClick={() => filterProperties('all')}
                >
                  All Properties
                </button>
                <button
                  className={activeFilter === 'top' ? 'active' : ''}
                  onClick={() => filterProperties('top')}
                >
                  Top Properties
                </button>
                <button
                  className={activeFilter === 'big' ? 'active' : ''}
                  onClick={() => filterProperties('big')}
                >
                  Biggest Home
                </button>
                <button
                  className={activeFilter === 'high' ? 'active' : ''}
                  onClick={() => filterProperties('high')}
                >
                  High Demand
                </button>
                <button
                  className={activeFilter === 'verified' ? 'active' : ''}
                  onClick={() => filterProperties('verified')}
                >
                  Verified Home
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Property listings */}
        {loading ? (
         // <div className="text-center">Loading properties...</div>
          <div className="text-center py-5">
            <Spin size="large" tip="Loading properties..." />
          </div>
        ) : (
          <>
            <div className="property-filter-area row custom-gutter">
              {currentProperties.length > 0 ? (
                currentProperties.map((item, i) => (
                  <div key={i} className="rld-filter-item col-lg-4 col-md-6 col-sm-12">
                    <div className="single-feature">
                      <div className="thumb">
                        {item.image && item.image.length > 0 ? (
                          <Slider {...carouselSettings}>
                            {item.image.map((img, imgIndex) => (
                              <div key={imgIndex}>
                                <img
                                  src={img.src}
                                  alt={`Property ${i + 1} - Image ${imgIndex + 1}`}
                                  className="img-fluid property-image"
                                  style={{ height: '250px', objectFit: 'cover', width: '100%' }}
                                />
                              </div>
                            ))}
                          </Slider>
                        ) : (
                          <img
                            src={publicUrl + "assets/img/placeholder-property.jpg"}
                            alt="No image available"
                            className="img-fluid"
                            style={{ height: '250px', objectFit: 'cover', width: '100%' }}
                          />
                        )}
                      </div>
                      <div className="details">
                        {item.icon && (
                          <a href="#" className="feature-logo">
                            <img src={publicUrl + item.icon} alt={imagealt} />
                          </a>
                        )}
                        <p className="author">
                          <i className="fa fa-user" /> {item.authorname || 'Unknown'}
                        </p>
                        <h6 className="title readeal-top">
                          <Link to={item.url || '#'}>{item.building_type}</Link>
                        </h6>
                        <h6 className="price">
                          {item.price}
                          {item.olderprice && <del> {item.olderprice}</del>}
                        </h6>
                        <ul className="info-list">
                          <li>
                            <img src={"/assets/img/icons/7.png"} alt={imagealt} />
                            {item.locality_Address || 'Address not available'}
                          </li>
                          {item.bedrooms && <li><i className="fa fa-bed"></i> {item.bedrooms} Beds</li>}
                          {/* {item.bathrooms && <li><i className="fa fa-bath"></i> {item.bathrooms} Baths</li>} */}
                          {item.area && <li><i className="fa fa-arrows-alt"></i> {item.area} sq ft</li>}
                        </ul>
                        <ul className="contact-list">
                          <li>
                            <a className="phone" href="#">
                              <i className="fa fa-phone" />
                            </a>
                          </li>
                          <li>
                            <a className="message" href="#">
                              <img src={publicUrl + "/assets/img/icons/8.png"} alt="message" />
                            </a>
                          </li>
                          <li className="readeal-top">
                            <Link className="btn btn-yellow" to={item.url || '#'}>
                              View Details
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-12 text-center">
                  <p>No properties found matching your criteria.</p>
                </div>
              )}
            </div>

            {/* Pagination */}
            {currentProperties.length < filteredProperties.length && (
              <div className="property-filter-menu portfolio-filter text-center mb-3">
                <button
                  className="btn btn-yellow"
                  onClick={loadMore}
                  disabled={loading}
                >
                  {loading ? 'Loading...' : 'Load More'}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Property;